<template>
    <div v-if="show" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
        <div class="relative top-20 mx-auto p-5 border w-[800px] shadow-lg rounded-md bg-white">
            <div class="mt-3">
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-sky-100">
                    <svg class="h-6 w-6 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
                    </svg>
                </div>
                <h3 class="text-lg leading-6 font-medium text-gray-900 mt-4 text-center">Bulk Export Contractor Profiles</h3>

                <!-- Filters Section -->
                <div class="mt-4 px-4">
                    <div class="mb-4">
                        <label for="role-filter" class="block text-sm font-medium text-gray-700">Role</label>
                        <select
                            id="role-filter"
                            v-model="selectedRole"
                            class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm rounded-md"
                        >
                            <option value="">All Roles</option>
                            <option v-for="role in roles" :key="role" :value="role">
                                {{ role }}
                            </option>
                        </select>
                    </div>

                    <!-- Contractors List -->
                    <div class="mt-4 border rounded-lg overflow-hidden">
                        <div class="bg-gray-50 px-4 py-2 border-b">
                            <div class="flex items-center">
                                <input
                                    type="checkbox"
                                    :checked="isAllSelected"
                                    @change="toggleSelectAll"
                                    class="h-4 w-4 text-sky-600 rounded border-gray-300 focus:ring-sky-500"
                                >
                                <span class="ml-2 text-sm font-medium text-gray-700">Select All</span>
                                <span class="ml-auto text-sm text-gray-500">{{ selectedCount }} selected</span>
                            </div>
                        </div>
                        <div class="max-h-[400px] overflow-y-auto">
                            <div v-for="contractor in filteredContractors" :key="contractor.id" 
                                 class="px-4 py-2 border-b hover:bg-gray-50">
                                <div class="flex items-center">
                                    <input
                                        type="checkbox"
                                        :checked="selectedContractors.includes(contractor.id)"
                                        @change="toggleContractor(contractor.id)"
                                        class="h-4 w-4 text-sky-600 rounded border-gray-300 focus:ring-sky-500"
                                    >
                                    <div class="ml-2">
                                        <div class="text-sm font-medium text-gray-900">
                                            {{ contractor.first_name }} {{ contractor.last_name }}
                                        </div>
                                        <div class="text-sm text-gray-500">
                                            {{ contractor.role }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex justify-end gap-3 mt-6">
                    <button 
                        @click="closeModal" 
                        class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                    >
                        Cancel
                    </button>
                    <button
                        @click="exportSelected"
                        :disabled="selectedCount === 0"
                        class="px-4 py-2 text-sm font-medium text-white bg-sky-600 rounded-md hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Export Selected ({{ selectedCount }})
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import adminService from '@/services/marketplace/admin.service';

export default {
    name: 'BulkExportModal',
    props: {
        show: {
            type: Boolean,
            required: true
        },
        contractors: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            selectedRole: '',
            selectedContractors: []
        }
    },
    computed: {
        roles() {
            return [...new Set(this.contractors.map(c => c.role))].filter(Boolean);
        },
        filteredContractors() {
            return this.contractors.filter(contractor => {
                return !this.selectedRole || contractor.role === this.selectedRole;
            });
        },
        selectedCount() {
            return this.selectedContractors.length;
        },
        isAllSelected() {
            return this.filteredContractors.length > 0 && 
                   this.filteredContractors.every(c => this.selectedContractors.includes(c.id));
        }
    },
    methods: {
        toggleContractor(id) {
            const index = this.selectedContractors.indexOf(id);
            if (index === -1) {
                this.selectedContractors.push(id);
            } else {
                this.selectedContractors.splice(index, 1);
            }
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.selectedContractors = [];
            } else {
                this.selectedContractors = this.filteredContractors.map(c => c.id);
            }
        },
        closeModal() {
            this.$emit('close');
            this.selectedRole = '';
            this.selectedContractors = [];
        },
        exportSelected() {
            if (this.selectedCount === 0) return;
            this.$emit('export', this.selectedContractors);
            this.closeModal();
        }
    }
}
</script>

<style scoped>
.fixed {
    animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}
</style>